import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH } from '../../constants/dims';

const Container = styled.section`
  width: 100%;
  position: relative;
  color: ${props => props.theme.contact.text};
  background-color: ${props => props.theme.contact.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: ${props => props.theme.contact.header.text};
  background-color: ${props => props.theme.contact.header.backgroundColor};
  padding: 20px;
  box-sizing: border-box;

  & > h2 {
    width: 100%;
    max-width: ${TABLET_WIDTH}px;
    margin-bottom: 0;
  }
`;

const Canvas = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  color: ${props => props.theme.contact.text};
  background-color: ${props => props.theme.contact.backgroundColor};

  & > .max-width {
    width: 100%;
    max-width: ${TABLET_WIDTH}px;
  }
`;

const Contact = () => {
  useEffect(() => {
    document.title = 'Brainquake: Contact Us';
  });

  return (
    <Container>
      <Header>
        <h2>Contact Us</h2>
      </Header>
      <Canvas>
        <div className="max-width">
          <h2>Stay in touch!</h2>
          <p>
            If you'd like to join our community's email list to stay on top of
            what we're up to, please email{' '}
            <a href="mailto:info@brainquake.com">info@brainquake.com</a>.
          </p>

          <h2>Support</h2>
          <p>
            If you’d like to get in touch with our customer support team, please
            email us at{' '}
            <a href="mailto:support@brainquake.com">support@brainquake.com</a>.
            We’ll get right back to you!
          </p>

          <h2>Research</h2>
          <p>
            If you’re interested in possible collaborations and research
            opportunities as part of our Mathematics Matters Project, please
            email us at{' '}
            <a href="mailto:mathmatters@brainquake.com">
              mathmatters@brainquake.com
            </a>
            .
          </p>

          <h2>Press Inquiries</h2>
          <p>
            If you are a member of the press, and you’d like more information
            about our program, please email{' '}
            <a href="mailto:info@brainquake.com">info@brainquake.com</a>.
          </p>

          <h2>Partnerships</h2>
          <p>
            If you’re interested in chatting with us about brand or business
            development partnerships, please email us at{' '}
            <a href="mailto:partners@brainquake.com">partners@brainquake.com</a>
            .
          </p>
        </div>
      </Canvas>
    </Container>
  );
};

export default Contact;
